import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { handleApiResponse } from '@src/api/apiClient/axiosClient.ts';
import { inAppNotificationApiClient } from '@src/api/tenant/inAppNotification/inAppNotificationApiClient.ts';
import {
  InAppNotification,
  InAppNotificationIndexResponse,
} from '@src/api/types/inAppNotification.ts';

interface TenantInAppNotificationState {
  notifications: InAppNotification[];
  latestCreatedAt: string | null;
}

const initialState: TenantInAppNotificationState = {
  notifications: [],
  latestCreatedAt: null,
};

export const fetchNotifications = createAsyncThunk('tenantInAppNotification/fetch', async () => {
  const res = await inAppNotificationApiClient.index();
  let result = { notifications: [], latest_created_at: '' } as InAppNotificationIndexResponse;
  handleApiResponse(res, (data) => {
    result = data;
  });
  return result;
});

const tenantInAppNotificationSlice = createSlice({
  name: 'tenantInAppNotification',
  initialState,
  reducers: {
    setNotifications: (state, action: PayloadAction<InAppNotificationIndexResponse>) => {
      state.notifications = action.payload.notifications;
      state.latestCreatedAt = action.payload.latest_created_at;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchNotifications.fulfilled, (state, action) => {
      state.notifications = action.payload.notifications;
      state.latestCreatedAt = action.payload.latest_created_at;
    });
  },
});

export const { setNotifications } = tenantInAppNotificationSlice.actions;
export default tenantInAppNotificationSlice.reducer;
